import React from 'react';
import { Button, Icon, Header, Segment, Popup, Loader, Form, Tab, Responsive } from 'semantic-ui-react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { IconHeader, FiltersOnStyle } from '../../Professor/ProfessorInputGrades/css';
import Filters from '../../Admin/CreateStudyProgram/Filters';
import request from '../../util/request';
import { fetchStudyCycle } from '../../Lookups/util';
import StudyPrograms from './StudyPrograms';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const fetchTitles = () => axios.get('/titles');

export default class StudentServiceStudyPrograms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            studyCycles: [],
            titles: [],
            results: [],

            data: [],
            orgUnits: [],
            orgUnit: null,

            loading: true,
            archived: localStorage.setItem('archived', false),

        };

        this.getStudyPrograms = this.getStudyPrograms.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        localStorage.removeItem('archived');
        let element = document.querySelectorAll('#myTab:nth-child(1)');
        element[0].childNodes[1].classList.remove('segment');

        request.fetchOrgUnits()
            .then(orgUnits => this.setState({ orgUnits }));

        if (localStorage.getItem('activeRole').substr(0, 8) !== 'Ministar') {
            this.getStudyPrograms(localStorage.getItem('orgUnitId'));
        } else {
            this.getStudyPrograms();
        }

        axios.all([fetchStudyCycle(), fetchTitles()])
            .then(axios.spread((studyCycleRes, titlesRes) => {
                this.setState({
                    studyCycles: studyCycleRes.data.map(el => ({
                        key: el.id, value: el.id, text: el.displayName
                    })),
                    titles: titlesRes.data
                });
            }));
    }

    getStudyPrograms(orgUnitId) {
        let obj = {};
        if ((localStorage.getItem('activeRole').substr(0, 8) === 'Ministar')) {
            axios.post(`study-programs/basic/${orgUnitId}`, { ...obj })
                .then(res => {
                    let white = true;
                    let data = res.data.map((el, index) => {
                        if (index === 0) { return { ...el, white }; } else if (res.data[index - 1].studyProgramBasic.studyCycles[0].name !== res.data[index].studyProgramBasic.studyCycles[0].name) {
                            white = false;
                            return { ...el, white };
                        }
                        return { ...el, white };
                    });
                    this.setState({ data, loading: false });
                })
                .catch(err => {
                    console.log('Failed to fetch study programs');
                });
        } else {
            axios.post('study-programs/basic', { ...obj })
                .then(res => {
                    let white = true;
                    let data = res.data.map((el, index) => {
                        if (index === 0) { return { ...el, white, studyProgramBasicName: el.studyProgramBasic.name }; } else if (res.data[index - 1].studyProgramBasic.studyCycles[0].name !== res.data[index].studyProgramBasic.studyCycles[0].name) {
                            white = !white;
                            return { ...el, white, studyProgramBasicName: el.studyProgramBasic.name };
                        }
                        return { ...el, white, studyProgramBasicName: el.studyProgramBasic.name };
                    });
                    this.setState({ data, loading: false });
                    // this.setState({ data: res.data.map(el => ({ ...el,  })), loading: false });
                })
                .catch(err => {
                    console.log('Failed to fetch study programs');
                });
        }
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });

        this.getStudyPrograms(value);
    }


    render() {
        const panes = [
            {
                menuItem: 'Aktivni studijski programi',
                render: () => (<Tab.Pane attached={false} responsive={Responsive}>
                    {this.state.loading ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                        : <div>
                            <StudyPrograms
                                archived={localStorage.setItem('archived', false)}
                                // active
                                data={this.state.data.filter(el => el.studyProgramBasic.archived !== true)}
                                studyCycles={this.state.studyCycles}
                            />
                        </div>}
                </Tab.Pane>)
            },
            {
                menuItem: 'Arhivirani studijski programi',
                render: () => (<Tab.Pane attached={false} responsive={Responsive}>
                    {this.state.loading ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                        : <div>
                            <StudyPrograms
                                archived={localStorage.setItem('archived', true)}
                                data={this.state.data.filter(el => el.studyProgramBasic.archived === true)}
                                studyCycles={this.state.studyCycles}
                                // active={false}
                            /></div>}
                </Tab.Pane>)
            }
        ];
        if (this.state.loading && localStorage.getItem('orgUnitId')) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;

        return (
            <div>
                <h1>Osnovni studijski programi</h1>
                {(localStorage.getItem('activeRole').substr(0, 8) === 'Ministar') &&
                <Segment.Group raised >
                    <Segment clearing>
                        <Header as="h3">
                            Odabir organizacione jedinice
                        </Header>
                    </Segment>
                    <Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field disabled={!this.state.orgUnits}>
                                    <label>Organizaciona jedinica</label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite organizacionu jedinicu"
                                        value={this.state.orgUnit}
                                        onChange={this.handleInputChange}
                                        name="orgUnit"
                                        options={this.state.orgUnits}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                <Form.Field />
                            </Form.Group>

                        </Form>
                    </Segment>
                </Segment.Group>

                }
                { ((localStorage.getItem('activeRole').substr(0, 8) === 'Ministar' && this.state.orgUnit) || localStorage.getItem('activeRole').substr(0, 8) !== 'Ministar') && <Segment.Group raised>
                    <Segment clearing>
                        <Header as="h3"> Spisak studijskih programa </Header>
                    </Segment>

                    <Segment>
                        <Tab id="myTab" menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} /></Segment>
                </Segment.Group>
                }
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudyPrograms/StudentServiceStudyPrograms.js